import type { FC, ReactNode } from 'react';

type RegularSearchWidgetProps = {
  children: ReactNode;
};

export const RegularSearchWidget: FC<RegularSearchWidgetProps> = ({
  children,
}) => {
  return <div className="mx-auto w-full max-w-laptop p-4">{children}</div>;
};
